module.exports = __webpack_public_path__ + "img/lunbo231.fccd358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo231.jpg
// module id = NaLm
// module chunks = 0